module.exports = __webpack_public_path__ + "img/activ-img2.acdd18ab.jpg";